import { HEADER_STICKED_HEIGHT } from '../../HeaderModule/constants/headerStickedHeight';

export const scrollToBlock = (hash: string) => {
  let checkedHash = hash;

  if (hash.length > 0 && hash[0] === '#') {
    checkedHash = checkedHash.slice(1);
  }

  const anchorElement = document.getElementById(checkedHash);
  const url = new URL(window.location.href);

  url.hash = `#${checkedHash}`;

  if (anchorElement) {
    window.scrollTo({
      top: anchorElement.getBoundingClientRect().top + window.pageYOffset - HEADER_STICKED_HEIGHT + 2,
      behavior: 'smooth',
    });
  }
  window.history.replaceState(null, '', url.href);
};
